module.exports = __webpack_public_path__ + "static/media/Burger.0210f26a.jpg";